import { useExceptionsStore } from "src/stores/exceptionsStore";

async function catchException(e, additionalData = {}) {
  console.error(e);

  try {
    console.log("CATCHING EXCEPTION :", e);
    // return
    const exceptionsStore = useExceptionsStore();
    await exceptionsStore.logException(e, additionalData);
  } catch (logError) {
    console.error("Failed to log exception to database:", logError);
  }
}

export default {
  catchException
};
